import { render, staticRenderFns } from "./LandSaleRequest.vue?vue&type=template&id=48bd4431&lang=pug&"
import script from "./LandSaleRequest.vue?vue&type=script&lang=js&"
export * from "./LandSaleRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports